import {Directive} from "@angular/core";

@Directive({
  selector:
    'ng2-utils-1, ng2-utils-2, ng2-utils-3, ng2-utils-4, ng2-utils-5,' +
    'ng2-utils-6, ng2-utils-7, ng2-utils-8, ng2-utils-9, ng2-utils-10,' +
    'ng2-utils-11, ng2-utils-12, ng2-utils-13, ng2-utils-14, ng2-utils-15,' +
    'ng2-utils-16, ng2-utils-17, ng2-utils-18, ng2-utils-19, ng2-utils-20'
})
export class Ng2UtilsDirective {} // dummy directive to allow non-standard tags



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/directives/ng2-utils.directive.ts